import FaqBlock from './components/FaqBlock.js';

export function loadFAQBlocks( loop ) {
	// Make sure all content is loaded in the backend before trying to run the script, otherwise wait and do it again.
	const faqItem = document.querySelector( '.question-list__item' );

	if ( loop && ! faqItem ) {
		setTimeout( () => loadFAQBlocks( true ), 500 );
		return;
	}

	// Fetch all FAQ blocks and instantiate a FaqBlock class for each of them.
	const faqContainers = document.querySelectorAll( '.wp-block-qala-blocks-faq-block' );

	faqContainers.forEach( faqContainer => {
		new FaqBlock( faqContainer );
	} );
}

loadFAQBlocks();
